import { ReactElement, useEffect, useState } from 'react';
import { useRouteLoaderData } from 'react-router-dom';
import { useBoostedPlanDataStore } from '../../../stores/useBoostedPlanDataStore';
import { usePlanLoadingStore } from '../../../stores/usePlanLoadingStore';
import PlanLoading from '../../icons/PlanLoading';
import { useVidaCountStore } from '../../../stores/useQuantidadeVidas';
import { usePlansDataStore } from '../../../stores/usePlansDataStore';
import { useFunctionarysDataStore } from '../../../stores/useFunctionarysDataStore';
import { useLoadingStore } from '../../../stores/useLoadingStore';

export function MainPurchaseSummaryContent(): ReactElement {
  const [empresa, setEmpresa] = useState(false);
  const individualPlanData: any = useRouteLoaderData('token');
  const bussinessPlanData: any = useRouteLoaderData('token-empresa');
  const GDFPlanData: any = useRouteLoaderData('token-servidor');
  const GDFPlanDataCopy: any = useRouteLoaderData('token-servidorPaP');

  let initialPlanData = individualPlanData;
  if (individualPlanData != undefined) {
    initialPlanData = individualPlanData;
  } else if (GDFPlanDataCopy) {
    initialPlanData = GDFPlanDataCopy;
  } else if (bussinessPlanData != undefined) {
    initialPlanData = bussinessPlanData;
  } else {
    initialPlanData = GDFPlanData;
  }
  const boostedPlanData = useBoostedPlanDataStore(state => state.data);

  const [data, setData] = useState(initialPlanData);
  const [anual, setAnual] = useState(false);
  const Produto_an = [989, 990, 991, 992];
  const [valor, setValor] = useState('0,00');
  const Vidas = useVidaCountStore(x => x.count);
  const setVidas = useVidaCountStore(x => x.setVidaCount);
  const funcionarios = useFunctionarysDataStore(x => x.data) || [];
  const planos = usePlansDataStore(state => state.data);
  const setLoading = useLoadingStore(state => state.setLoading);

  useEffect(() => {
    setVidas(1);
    if (bussinessPlanData) {
      setEmpresa(true);
    } else {
      setEmpresa(false);
    }
  }, []);

  useEffect(() => {
    const selectedPlanData =
      boostedPlanData &&
      Object.keys(boostedPlanData).length !== 0 &&
      boostedPlanData != data
        ? boostedPlanData
        : initialPlanData;

    setData(selectedPlanData);
  }, [boostedPlanData, initialPlanData]);

  const extractNumber = (text: string): number => {
    const match = text.match(/\d+/); // Encontra o primeiro número na string
    return match ? parseInt(match[0], 10) : 0; // Converte o número encontrado em inteiro ou retorna 0
  };

  // Ordenar carencias com base no número extraído
  const sortedCarencias = [...(data?.carencias ?? [])].sort((a, b) => {
    const numA = extractNumber(a.carencia.nm_descricaocarencia);
    const numB = extractNumber(b.carencia.nm_descricaocarencia);
    return numA - numB;
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    if (bussinessPlanData) {
      calculaValorTotalByPlan(data);
      return;
    }

    calculaValorTotal(data);
  }, [data, Vidas, funcionarios, planos]);

  const calculaValorTotal = (planData = data) => {
    const produto = planData?.produtoComercial?.id_prodcomerc;
    const valorPlano = planData?.formasPagamento?.[0]?.vl_valor;

    if (!valorPlano) {
      setValor('0,00');
      setAnual(false);
      return;
    }

    if (Produto_an.includes(produto)) {
      const roundedNum = (Math.round(Number(valorPlano) * 1200) / 100).toFixed(
        2,
      );
      const formattedNum = roundedNum.replace('.', ',');
      setValor(formattedNum);
      setAnual(true);
      return;
    }

    setAnual(false);

    if (Vidas > 1) {
      if (produto == 1055) {
        const roundedNum = (Number(valorPlano) * 2).toFixed(2);
        const formattedNum = roundedNum.replace('.', ',');
        setValor(formattedNum);
        return;
      }
      const roundedNum = (Number(valorPlano) * Number(Vidas)).toFixed(2);
      const formattedNum = roundedNum.replace('.', ',');
      setValor(formattedNum);
    } else {
      setValor(String(valorPlano).replace('.', ','));
    }
  };
  const calculaValorTotalByPlan = (planData = data) => {
    if (bussinessPlanData && Vidas > 1) {
      if (Array.isArray(funcionarios) && funcionarios.length > 0) {
        let valorNumber = 0;
        for (const funcionario of funcionarios) {
          if (planos && planos.length > 0) {
            const planoFuncionario = planos.find(
              plano => String(plano.value) === funcionario.planoId,
            );
            if (planoFuncionario) {
              valorNumber += Number(planoFuncionario.price);
            }
            const dependentes = funcionario.dependentes || [];
            if (Array.isArray(dependentes) && dependentes.length > 0) {
              for (const dependente of dependentes) {
                const planoDependente = planos.find(
                  plano => String(plano.value) === dependente.planoId,
                );
                if (planoDependente) {
                  valorNumber += Number(planoDependente.price);
                }
              }
            }
          } else {
            calculaValorTotal();
          }
        }
        const roundedNum = Number(valorNumber).toFixed(2);
        const formattedNum = roundedNum.replace('.', ',');
        setValor(formattedNum);
      }
    } else {
      //setLoading(true);
      const valorPlano = planData?.formasPagamento?.[0]?.vl_valor;
      setValor(valorPlano ? String(valorPlano).replace('.', ',') : '0,00');
    }
  };

  const loading = usePlanLoadingStore(state => state.loading);

  return (
    //TODO Mostrar mensagem que o plano foi trocado - planBoost
    <>
      <h3 className="text-high-emphasis text-xl">Resumo da compra</h3>
      <span className="flex justify-between uppercase text-medium-emphasis text-xs font-normal">
        <span className="block">
          <span className="block">Plano escolhido:</span>
          <strong className="block text-neutral-600 normal-case text-sm font-normal">
            {data.produtoComercial.nm_prodcomerc}
          </strong>
        </span>
        <span className="block">
          <span className="block">Vidas:</span>
          <strong className="block text-neutral-600 normal-case text-sm font-normal">
            {Vidas}
          </strong>
        </span>
      </span>
      {/* <span className="uppercase text-medium-emphasis text-xs font-normal block">
        <span className="block mb-1">Valor plano:</span>
        <div className="w-[95px] h-5 bg-gradient-to-r from-[#EBE8E8] to-[#FAFAFA] rounded-xl" />
      </span> */}
      {loading ? (
        <PlanLoading />
      ) : anual ? (
        <div className="h-[95px] bg-[#F8F8FB] py-3 flex flex-col justify-center items-center ">
          <span className="uppercase text-secondary-main rounded-xl block mb-[11px]">
            Valor total
          </span>
          {/* <span className="text-[0.625rem] mb-1">A partir de</span> */}
          <strong className="font-normal text-base text-high-emphasis">
            R${' '}
            <span className="text-[2rem] font-semibold">
              {
                //TODO pegar valor da forma de pagamento selecionada e validar se for boleto nu_pagamento_unico
              }
              {valor}
            </span>{' '}
            por ano
          </strong>
        </div>
      ) : empresa ? (
        <div className="h-[95px] bg-[#F8F8FB] py-3 flex flex-col justify-center items-center ">
          <span className="uppercase text-secondary-main rounded-xl block mb-[11px]">
            Valor total
          </span>
          {/* <span className="text-[0.625rem] mb-1">A partir de</span> */}
          <strong className="font-normal text-base text-high-emphasis">
            R${' '}
            <span className="text-[2rem] font-semibold">
              {
                //TODO pegar valor da forma de pagamento selecionada e validar se for boleto nu_pagamento_unico
              }
              {valor}
            </span>{' '}
            por mês
          </strong>
        </div>
      ) : (
        <div className="h-[95px] bg-[#F8F8FB] py-3 flex flex-col justify-center items-center ">
          <span className="uppercase text-secondary-main rounded-xl block mb-[11px]">
            Valor total
          </span>
          <strong className="font-normal text-base text-high-emphasis">
            R$ <span className="text-[2rem] font-semibold">{valor}</span> por
            mês
          </strong>
        </div>
      )}
      <div className="">
        <span className="text-[0.625rem] text-[#777777]">Carência</span>
        {sortedCarencias
          ? sortedCarencias.map((carencias: any) => (
              <p
                key={carencias.carencia.nm_descricaocarencia}
                className="text-xs text-[#394146]"
              >
                {carencias.carencia.nm_descricaocarencia}
              </p>
            ))
          : ''}
      </div>
    </>
  );
}
